import styled from "styled-components";

const StyledPopupContainer = styled.div`
    left: 0;
    right: 0; 
    bottom: 0;
    top: 0;
    padding: 10px;
    position: absolute;
    z-index: 100;
    background: #b6b6b67d; //add filter
    display: flex;
    justify-content: center;
    align-items: center;
`;
export default StyledPopupContainer;
